"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToStartYourProject() {
  const {
    ref: word1Ref,
    isVisible: word1Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word2Ref,
    isVisible: word2Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word3Ref,
    isVisible: word3Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return;
}